import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Input,
  TextArea,
  DatePicker,
  SelectOptions,
  // HintModal
} from "components";

import * as styles from "./editDeals.styles";
import { Button, FlexRow, FlexColumn } from "appStyles";
import styled, { css } from "react-emotion";

import { toast } from "react-toastify";
import StyledToast from "../../../Tools/StyledToast";
import Alert from "@material-ui/lab/Alert";

const topBanner = css`
  background-color: #aed9da;
  height: 57px;
  padding: 20px;
  color: white;
  border-radius: 5px 5px 0px 0px;
`;
const boldButton = css`
  display: inline-block;
  width: 100px;
  text-align: center;
  border-radius: 5.5px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
`;

const selectStyle = css`
  padding: 0px;
  text-align: center;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  cursor: pointer;
  color: black;
  width: 85px;
  font-size: 15px;
  text-align: left;
  padding-left: 5px;
  border: 0px;
  outline: 0px;
  border: 1px solid #979797;

  select::-ms-expand {
    display: block;
  }
  /* Removes the default <select> styling */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* Positions background arrow image */
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA20lEQVQ4T+3SL0tDcRjF8c8V2YrJqHF1VTAIK5rtewGCb2BNWBIcmKy+gYW9ATGJIPblwZLNZBqMyQ9+Vy4/7j/wxj31Oc8XzjlPpuPJOubZA/+faJphDxPMsGnA96P2oahNgUd4xRpjbCugh5jjFJf4yXVlLR/jDR+4wS6BHuAZZxjhu7ivepsTvGMRbeXQoH/ENS7wlTqo+8NBhD7hPh7e4TbCVmVxND32MNoPoGB1Gm0uqwprAoa7c7xEwBU+69pvAwz3ockw4QNqpy2wifO33wNbR1Up7DzDX2zcHRV0yPnBAAAAAElFTkSuQmCC");
  background-repeat: no-repeat;
  background-position: 60px center;
`;

const titleStyle = css`
  white-space: nowrap;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
`;
const topHeader = css`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
`;
const formStyle = css`
  position: relative;
  padding: 20px;
  background: white;
  border-radius: 0px 0px 5px 5px;
`;
const H2 = styled("h2")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
  color: #1f3747;
  margin: auto;
`;
const container = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  position: relative;
  border-radius: 5px;
  margin-bottom: 3em;
`;
const newPStyle = css`
  margin-inline-end: auto;
  margin-top: 20px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
`;

const Deal = (props) => {
  const [error, setError] = useState("");

  const notify = (action) => {
    switch (action) {
      case "create":
        toast(
          StyledToast({
            message: "🤗 The deal " + props.deal.title + " was created!",
            confirm: true,
          }),
          {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          }
        );
        break;
      case "update":
        toast(
          StyledToast({
            message: "👏 The deal " + props.deal.title + " was updated!",
            confirm: true,
          }),
          {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          }
        );
        break;
      case "delete":
        toast(
          StyledToast({
            message: "❌ The deal " + props.deal.title + " was deleted!",
          }),
          {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          }
        );
        break;
      default:
        toast.error(action, {
          position: "bottom-right",
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
    }
  };
  const putDeal = () => {
    props.putDeal(props.deal);
    props.updateActiveEditor(null);
    notify("update");
  };

  const createDeal = () => {
    if (props.deal.title) {
      props.createDeal({
        appId: props.appId,
        ...props.deal,
      });
      props.updateActiveEditor(null);
      notify("create");
    } else {
      setError("Deal name cannot be empty");
      window.setTimeout(() => {
        setError("");
      }, 2000);
    }
    // props.actions.updateActiveEditor(null);
  };

  const deleteDeal = () => {
    if (isNewDeal) {
      props.removeDeal(props.deal);
    } else {
      props.deleteDeal(props.deal);
    }
    // props.actions.updateActiveEditor(null);
    props.updateActiveEditor(null);
    notify("delete");
  };

  const update = (field) => (value) => {
    // edge case for maxUses
    if (field === "maxUses") {
      value === null ? (value = null) : (value = parseInt(value));
    }

    props.updateDeal({
      ...props.deal,
      [field]: value,
    });

    // JSON.stringify(props);
    // console.log("printing prop actions " + props);
    // props.updateActiveEditor(null);
  };

  const maxUseOptions = (maxUses) => {
    let options = [
      {
        value: null,
        label: "Unlimited",
      },
    ];

    for (let i = 1; i < 21; i++) {
      options.push({
        value: i,
        label: i,
      });
    }

    return (
      <SelectOptions
        width="8em"
        options={options}
        setValue={update("maxUses")}
        value={maxUses}
        className={selectStyle}
      />
    );
  };

  const {
    id,
    description,
    finePrint,
    title,
    expiration,
    maxUses,
    retired,
    requiresCode,
    redemptionType,
  } = props.deal;
  // JSON.stringify(props);
  // console.log("printing prop actions " + props);
  const isNewDeal = id === "newDeal";
  // const parsedExpiration = new Date(expiration).toLocaleTimeString("en-US");
  // console.log(parsedExpiration);
  // const parsedDate = new Date(expiration).toLocaleDateString("en-US");
  // console.log(parsedDate);

  return (
    <div className={container}>
      {/* <div className={topBanner}>
        <p className={topHeader}>Deal Information</p>
      </div> */}

      <form className={formStyle}>
        {!isNewDeal && <H2 style={{ marginBottom: "20px" }}>Edit Deal</H2>}
        {isNewDeal && <H2 style={{ marginBottom: "20px" }}>New Deal</H2>}
        <FlexRow style={{ height: "auto" }}>
          <FlexColumn
            width="40%"
            style={{ margin: "0px", marginRight: "20px" }}
          >
            <Input
              field="Deal Name"
              validateInput="true"
              defaultValue={title}
              onChange={update("title")}
            />

            <TextArea
              width="100%"
              height="5rem"
              placeholder="Description"
              text={description}
              onChange={update("description")}
            />

            <TextArea
              width="100%"
              height="5rem"
              placeholder="Fine Print"
              text={finePrint}
              onChange={update("finePrint")}
            />
            {/* <p className={newPStyle}>Can this deal be purchased?</p> */}
          </FlexColumn>
          <FlexColumn width="60%" style={{ marginTop: "0px" }}>
            <DatePicker
              // className={styles.datePicker}
              datePickerProps={{
                showTimeSelect: true,
                timeFormat: "hh:mm a",
                timeIntervals: 10,
                timeCaption: "time",
                dateFormat: "MM/dd/yyyy hh:mm a",
                style: {
                  marginLeft: "0px",
                  innerWidth: "200px",
                  innerBackgroundPosition: "175px center",
                },
              }}
              isExpirationDate={true}
              title="Expiration Date:"
              selected={expiration}
              onChange={update("expiration")}
            />
            <FlexRow margin="2em auto 2em auto">
              <span className={titleStyle}> Max # of uses: </span>
              {maxUseOptions(maxUses)}
            </FlexRow>
          </FlexColumn>
        </FlexRow>
        <FlexRow style={{ justifyContent: "flex-end", height: "auto" }}>
          {error && <Alert severity="error">{error}</Alert>}
          {!retired && (
            <Button
              background="#F17F7F"
              onClick={deleteDeal}
              className={boldButton}
            >
              Delete
            </Button>
          )}
          {!isNewDeal && (
            <Button
              background="#89D2D3"
              onClick={putDeal}
              className={boldButton}
              style={{ width: "140px" }}
            >
              Save Changes
            </Button>
          )}

          {isNewDeal && (
            <Button
              background="#89D2D3"
              onClick={createDeal}
              className={boldButton}
            >
              Create
            </Button>
          )}

          {!!retired && (
            <Button
              background="#89D2D3"
              onClick={createDeal}
              className={boldButton}
            >
              Recreate Deal
            </Button>
          )}
        </FlexRow>
      </form>
    </div>
  );
};

Deal.propTypes = {
  deal: PropTypes.object,
  putDeal: PropTypes.func,
  deleteDeal: PropTypes.func,
  updateDeal: PropTypes.func,
};

export default Deal;
